"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMarketingResourceLinkClick = void 0;
/**
 * A builder for MarketingResourceLinkClick
 *
 * @param data - The event data
 * @return The formatted event data for MarketingResourceLinkClickEvent
 */
function createMarketingResourceLinkClick(data) {
    return {
        name: 'MarketingResourceLinkClick',
        environments: ['browser'],
        data: data,
    };
}
exports.createMarketingResourceLinkClick = createMarketingResourceLinkClick;
//# sourceMappingURL=createMarketingResourceLinkClick.js.map